import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, toRefs } from 'vue';
import {
  AccountAddress, getAccountRoute, shortenPublicKey, toPublicKey,
} from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    address: null
  },
  setup(__props: any) {

const props = __props as {
  address: AccountAddress | undefined | null,
}



const { address } = toRefs(props);
const publicKey = computed(() => (address.value ? toPublicKey(address.value) : null));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(publicKey) ? 'router-link' : 'span'), {
      to: _unref(publicKey) ? _unref(getAccountRoute)(_unref(publicKey)) : {},
      class: "text-gray-500 hover:text-gray-900"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(publicKey) ? _unref(shortenPublicKey)(_unref(publicKey), 10) : '—'), 1)
      ]),
      _: 1
    }, 8, ["to"]))
  ]))
}
}

})